import React from "react";
import { List, Card, Typography, Progress, Button, Avatar, Space, Empty } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import { formatDateOnly } from "Common/Components/FormatDateTime";
import { useLocation, useNavigate } from "react-router-dom";
import AllTrainings from "PlatForms/OrgLMS/Hooks/useTrainingList";


const { Text } = Typography;

export const TrainingSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { enrolledTrainings, loading } = AllTrainings();
  const { darkMode = false } = location.state || {};

  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
    },
    avatarIcon: {
      backgroundColor: darkMode ? "#2a2a2a" : "#f0f0f0",
      color: darkMode ? "#ffffff" : "#1890ff",
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
    noData: {
      textAlign: "center",
      padding: "24px 0",
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "#999",
    },
  };

  return (
    <Card
      loading={loading}
      title={
        <Space style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={styles.cardTitle}>Trainings</span>
        </Space>
      }
      style={{ ...styles.card, ...styles.trainingCard }}
      headStyle={styles.cardTitle}
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {enrolledTrainings.length === 0 ? (
        <Empty description="No Trainings Available" />
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={enrolledTrainings}
          renderItem={(training) => (
            <List.Item style={styles.listItem} className="clickable-list-item">
              <List.Item.Meta
                avatar={<Avatar icon={<ApartmentOutlined />} style={styles.avatarIcon} />}
                title={
                  <Text strong style={styles.textColor}>
                    {training.title}
                  </Text>
                }
                description={
                  <>
                    <Progress
                      percent={training.progress}
                      size="small"
                      strokeColor={darkMode ? "#ffffff" : "#1890ff"}
                      format={(percent) => (
                        <span
                          style={{
                            color: darkMode ? "#ffffff" : "#000000",
                          }}
                        >
                          {percent}% complete
                        </span>
                      )}
                    />
                    <Text style={styles.secondaryTextColor}>
                      {training.totalLearners} learners • Ends on:{" "}
                      {`${formatDateOnly(training.endDate)}`}
                    </Text>
                  </>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};
